export default {
  TOGGLE_DETAIL_VISIBILITY: "TOGGLE_DETAIL_VISIBILITY",
};
